import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";
import { ChartOfAccountsTemplateCallbacks } from "../ChartOfAccountsTemplatesList";
import styles from "./ChartOfAccountsTemplateEntitiesCell.module.scss";

type Meta = ViewTableMeta<ChartOfAccountsTemplateCallbacks, never>;

// Count of entities a template has been applied to. Clicking the count opens
// the applied-entities drawer; disabled when the template has never been
// applied (count === 0).
export const ChartOfAccountsTemplateEntitiesCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => {
        const meta = (table.options.meta ?? {}) as Meta;
        const count = row.original.appliedEntitiesCount;
        const templateId = row.original.id;

        return (
            <ViewTableCell captureClicks className={styles.cell}>
                <Button
                    variant="secondary"
                    size="sm"
                    disabled={count === 0}
                    onClick={() =>
                        meta.callbacks?.onViewAppliedEntities(templateId)
                    }
                >
                    {count}
                </Button>
            </ViewTableCell>
        );
    },
);
